import { render, staticRenderFns } from "./modal-discard.vue?vue&type=template&id=83cb41b2&scoped=true"
import script from "./modal-discard.vue?vue&type=script&lang=js"
export * from "./modal-discard.vue?vue&type=script&lang=js"
import style0 from "./modal-discard.vue?vue&type=style&index=0&id=83cb41b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cb41b2",
  null
  
)

export default component.exports